import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface LoginPromptRequest {
  summary: string;
  detail: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoginPrompt {
  private readonly subject = new Subject<LoginPromptRequest>();
  readonly prompts$ = this.subject.asObservable();

  require(detail = 'Debes iniciar sesion para continuar', summary = 'Inicia sesion') {
    this.subject.next({ summary, detail });
  }
}
